function footerTabsFnc(){
  if (window.matchMedia('(min-width: 990px)').matches) {
    document.querySelectorAll('footer .footer__content-top .accordion details').forEach(item => {
      item.setAttribute("open", "");
      item.querySelector('summary').setAttribute("aria-expanded", true);
    });
  } else {
    document.querySelectorAll('footer .footer__content-top .accordion details').forEach(item => {
      item.removeAttribute("open");
      item.querySelector('summary').setAttribute("aria-expanded", false);
    });
  };
}
footerTabsFnc();
window.addEventListener('resize', function(event){
  footerTabsFnc();
});